$(document).ready(function() {
  $(".subsmenuss").closest("li").addClass("parentlis"); 
  $(".drawer__menu .sliderule__wrapper:first-child .mobile__menu__dropdown button.sliderow").closest(".sliderow__links").addClass("parerrntlis"); 
$(".parentlis").hover(function () {
    $(this).toggleClass("activeparen").siblings().removeClass('activeparen');
});
})
// $(document).on('click', '.parentlis', function() {
//    $(this).toggleClass('activeparen').siblings().removeClass('activeparen');
//   e.stopPropagation();
// });
// $(document).on("click", function(a) {
//   if ($(a.target).is(".parentlis") === false) {
//     $('.parentlis').removeClass('activeparen');
//   }
// });

// $(".parentlis").hover(
//   function () {
//     $(this).addClass("activeparen");
//   },
//   function () {
//     $(this).removeClass("activeparen");
//   }
// );
